import React, { useEffect, useState } from 'react';
import AdminLayout from '../layout/AdminLayout';
import Header from '../layout/Partials/Header';
import Loading from '../common/Loading';
import api from '../../api';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Typography } from '@material-ui/core';
import ApiKeyForm from './ApiKeyForm';

const ApiKey = () => {
    const [loading, setLoading] = useState(true);
    const [key, setKey] = useState(null);

    const getApiKey = () => {
        api.settings
            .getApiKey()
            .then((results) => {
                console.log(results);
                setKey(results);
            })
            .catch((err) => {
                console.log(err);
                setKey({ apikey: '' });
                setLoading(false);
            });
    };

    const saveApiKey = (values) => {
        setLoading(true);

        api.settings
            .setApiKey({ apiKey: values.apiKey })
            .then((results) => {
                setKey(results);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        if (key) setLoading(false);
    }, [key]);

    useEffect(() => {
        getApiKey();
    }, []);

    return (
        <AdminLayout>
            <div className="o-page">
                <Header>
                    <h2 className="c-navbar__title">Login Notification</h2>
                </Header>
                {!loading ? (
                    <div className="container">
                        <div className="row">
                            <div className="col-md-8 col-xl-8 u-m-auto">
                                <div className="c-card">
                                    <div className="o-line">
                                        <Typography variant={'h5'}>
                                            API Key
                                        </Typography>
                                    </div>

                                    <hr className="u-mt-small u-mb-medium" />
                                    <Alert severity="info">
                                        <AlertTitle>Info</AlertTitle>
                                        Please be aware you may only have one
                                        api key valid at any given time, if you
                                        generate a new api key all previous
                                        external connection you have setup will
                                        need to be updated with the new key.
                                    </Alert>
                                    <ApiKeyForm
                                        initialValues={key}
                                        submit={saveApiKey}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <Loading />
                )}
            </div>
        </AdminLayout>
    );
};

export default ApiKey;
